module.exports = __webpack_public_path__ + "static/media/the-queen-is-dead.48118f73.jpg";